import { render } from "./KitabelerEserler.vue?vue&type=template&id=47513beb"
import script from "./KitabelerEserler.vue?vue&type=script&lang=js"
export * from "./KitabelerEserler.vue?vue&type=script&lang=js"

import "./KitabelerEserler.vue?vue&type=style&index=0&id=47513beb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__